import { get } from '../../../utils/api';

export default {
  getPage: alias => get({ url: 'page/get', data: { alias } }),
  getCompositeDetail: alias => get({ url: 'page/composite-detail', data: { alias } }),
  getCompositeList: () => get({ url: 'page/composite-list' }),
};
